import {
  Box,
  Container,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import React, { useState } from "react";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { useDispatch } from "react-redux";
import AgentsData from "../../Components/Agents";
import MultiAgent from "../../Components/MultiAgents";
import { useLocation } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ flex: 1 }}
    >
      {value === index && <Box sx={{ py: 2, height: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Agents = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"));

  // Tab state
  const [value, setValue] = React.useState<number>(location.state?.tabId ?? 0);

  // Handle tab change
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3, height: "calc(100vh - 81px)" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            //position: { xs: "fixed", sm: "static" },
            //bottom: { xs: "0px", sm: "unset" },
            //left: { xs: "0px", sm: "unset" },
            //right: { xs: "0px", sm: "unset" },
            background: variables.whiteColor,
            //boxShadow: { xs: "0px 4px 10px rgba(0, 0, 0, 0.2)", sm: "none" },
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* Dynamically updated Breadcrumb */}
          <Breadcrumb data={[{ name: "Agents", path: "" }]} />

          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{ 
              minHeight: { xs: "40px", sm: "68px" }, 
              height: { xs: "40px", sm: "68px" }, 
              mt: { xs: "0", sm: "12px" }, 
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Tab
              icon={<TextSnippetIcon />}
              iconPosition="start"
              label="Agent"
              {...a11yProps(0)}
              sx={{
                minHeight: "32px",
                height: "32px",
                textTransform: "capitalize",
                width: { xs: "50%", sm: "auto" }, // 50% on mobile, auto on larger screens
              }}
            />
            <Tab
              icon={<AccountTreeOutlinedIcon />}
              iconPosition="start"
              label="Multi-Agent"
              {...a11yProps(1)}
              sx={{
                minHeight: "32px",
                height: "32px",
                textTransform: "capitalize",
                width: { xs: "50%", sm: "auto" }, // same here
              }}
            />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <AgentsData />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MultiAgent />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Agents;
